import { MatSnackBarConfig } from "@angular/material/snack-bar";
import { createAction, props } from "@ngrx/store";

const prefix = "[Notification]";

export const snackbarOpen = createAction(
  `${prefix} Snackbar Open`,
  props<{
    message: string;
    action?: string;
    config?: MatSnackBarConfig;
    reload?: boolean;
    copyText?: string;
  }>(),
);

export const snackbarClose = createAction(`${prefix} Snackbar Close`);
